import React from 'react';
import { MultipartLessonDetail } from '../../types';
import Section from './Section';

interface Props {
    multipartLesson: MultipartLessonDetail
}

/* eslint-disable react/no-danger */

export default ({ multipartLesson }: Props) => (
    <div>
        <h3>{multipartLesson.title}</h3>
        <div dangerouslySetInnerHTML={{ __html: multipartLesson.openingText }} />
        {multipartLesson.lessonSections.map(lessonSection => (
            <Section
                key={lessonSection.id}
                section={lessonSection}
            />
        ))}
    </div>
);
